export default __webpack_public_path__ + "static/media/food.846e0ec2.svg";